import EditProductDataModal from './EditProductDataModal';

export default EditProductDataModal;
